export default __webpack_public_path__ + "static/media/decada-0080-0006-min.1e45cc9f.jpg";